import React, { useState } from 'react';

import CoachingScheduleUpcomingSessions from './CoachingScheduleUpcomingSessions';
import CoachingScheduleDateHeader from './CoachingScheduleDateHeader';
import { getWeeklyTimeframe } from 'coaching/lib/timeIntervals';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import GetCoachingScheduleContainer from 'coaching/containers/GetCoachingScheduleContainer';
import ErrorReporter from 'app/components/ErrorReporter';
import Text from 'components/Text';
import Notice from 'components/Notice';

import EventTracking from 'lib/EventTracking';
import { coachDashboardPrefix } from 'coaching/components/CoachDashboard';

type Props = {};

export default function CoachingScheduleView(props: Props) {
  const [weekOffset, setWeekOffset] = useState<number>(0);
  const { startDateTime, endDateTime } = getWeeklyTimeframe(weekOffset);
  const startDateTimeString = startDateTime.toISOString();
  const endDateTimeString = endDateTime.toISOString();

  const renderError = () => {
    return (
      <ErrorReporter error="Coaching - couldn't load data">
        <Text align="center">
          <Notice color="whiteout">
            Sorry—no data is available at this time. Try refreshing the page.
          </Notice>
        </Text>
      </ErrorReporter>
    );
  };

  return (
    <React.Fragment>
      <GetCoachingScheduleContainer
        startDateTime={startDateTimeString}
        endDateTime={endDateTimeString}>
        {({ loading, error, coachingDashboardScheduleInstances }) => {
          if (loading) {
            return <CenteredLoadingIndicator data-test="centered-loading" />;
          }

          if (error) {
            console.error(error);
            return renderError();
          }

          return (
            <div data-test="coaching-schedule-view">
              <CoachingScheduleDateHeader
                onWeekForward={() => {
                  setWeekOffset(prev => prev + 1);
                  EventTracking.trackKey(`${coachDashboardPrefix}.coach_dashboard_schedule.week_date_picker_next_week.click`);
                }}
                onWeekBack={() => setWeekOffset(prev => prev - 1)}
                weekOffset={weekOffset}
                startDateTime={startDateTimeString}
                endDateTime={endDateTimeString}
              />

              <CoachingScheduleUpcomingSessions
                weekOffset={weekOffset}
                instances={coachingDashboardScheduleInstances}
              />
            </div>
          )
        }}
      </GetCoachingScheduleContainer>
    </React.Fragment>
  );
}
